import GlobalErrorContent from './GlobalErrorContent'

const ErrorPage = () => {
  return (
    <div className="flex h-full pt-10 md:pt-20 justify-center md:justify-start">
      <div>
        <img
          className="relative w-48 hidden md:block mr-48 mt-44"
          src="/images/eight-ball.svg"
          alt="Eight ball"
        />
      </div>
      <GlobalErrorContent />
    </div>
  )
}

export default ErrorPage
